var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',{attrs:{"disabled":_vm.disableImportButton},on:{"click":function($event){$event.preventDefault();return _vm.openModal.apply(null, arguments)}}},[_vm._t("default")],2),_c('div',{ref:"holder",staticClass:"holder-style"})])}
var staticRenderFns = []

export { render, staticRenderFns }